import React from 'react';
import { ConfigProvider } from 'antd';
import { useIsRTL } from '../../utils/rtl';
import { ThemeProvider, DefaultTheme } from 'styled-components';
import { GlobalStyles } from '../../styles/global';
import rtlStyles from '../../styles/rtl';
import ltrStyles from '../../styles/ltr';

interface RTLProviderProps {
  children: React.ReactNode;
}

const RTLProvider: React.FC<RTLProviderProps> = ({ children }) => {
  const isRTL = useIsRTL();
  const direction = isRTL ? 'rtl' : 'ltr';

  // Create a proper theme object with the styles and direction
  const theme: DefaultTheme = {
    direction,
    styles: isRTL ? rtlStyles : ltrStyles,
    // Add any other theme properties you need
    colors: {
      primary: '#1890ff',
      secondary: '#52c41a',
      error: '#f5222d',
      warning: '#faad14',
      info: '#1890ff',
      success: '#52c41a',
    },
  };

  return (
    <ConfigProvider direction={direction}>
      <ThemeProvider theme={theme}>
        <div dir={direction} className={`app-container ${direction}`}>
          <GlobalStyles />
          {children}
        </div>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default RTLProvider;
